// Odds & currency formatting helpers for UK-first display.
// Odds are stored canonically as American integers. Convert to display format only.

export function americanToDecimal(a) {
  if (a === null || a === undefined || a === 0 || isNaN(a)) return null;
  if (a > 0) return 1 + a / 100;
  return 1 + 100 / Math.abs(a);
}

export function americanToFractional(a) {
  const dec = americanToDecimal(a);
  if (dec === null) return null;
  const target = dec - 1;
  if (target <= 0) return "0/1";
  let best = { num: 1, den: 1, err: Infinity };
  for (let den = 1; den <= 20; den++) {
    const num = Math.round(target * den);
    if (num <= 0) continue;
    const err = Math.abs(num / den - target);
    if (err < best.err - 1e-9) best = { num, den, err };
    if (err < 0.005) break;
  }
  return `${best.num}/${best.den}`;
}

export function formatOdds(american, fmt = "decimal") {
  if (american === null || american === undefined || american === 0 || isNaN(american)) return "—";
  const a = Number(american);
  if (fmt === "american") return a > 0 ? `+${a}` : `${a}`;
  if (fmt === "fractional") return americanToFractional(a) || "—";
  const d = americanToDecimal(a);
  return d ? d.toFixed(2) : "—";
}

export function parseOddsInput(input, fmt = "decimal") {
  // Convert a user-entered odds string in the given format to American integer.
  if (input === null || input === undefined || input === "") return 0;
  const s = String(input).trim();
  if (fmt === "american") {
    const n = parseInt(s.replace(/[+\s]/g, ""), 10);
    return isNaN(n) ? 0 : n;
  }
  if (fmt === "fractional") {
    const m = s.match(/^(\d+)\s*\/\s*(\d+)$/);
    if (!m) return 0;
    const num = parseInt(m[1], 10), den = parseInt(m[2], 10);
    if (!den) return 0;
    const dec = 1 + num / den;
    return decimalToAmerican(dec);
  }
  // decimal
  const d = parseFloat(s);
  if (isNaN(d) || d <= 1) return 0;
  return decimalToAmerican(d);
}

function decimalToAmerican(dec) {
  if (dec >= 2) return Math.round((dec - 1) * 100);
  if (dec > 1) return -Math.round(100 / (dec - 1));
  return 0;
}

const CURRENCY_LOCALE = { GBP: "en-GB", USD: "en-US", EUR: "en-GB" };

export function formatCurrency(amount, currency = "GBP") {
  const n = Number(amount) || 0;
  try {
    return new Intl.NumberFormat(CURRENCY_LOCALE[currency] || "en-GB", {
      style: "currency",
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(n);
  } catch {
    const sym = currency === "USD" ? "$" : currency === "EUR" ? "€" : "£";
    return `${sym}${n.toFixed(2)}`;
  }
}

export function currencySymbol(currency = "GBP") {
  return currency === "USD" ? "$" : currency === "EUR" ? "€" : "£";
}

export const ODDS_FORMAT_LABEL = {
  decimal: "Decimal (UK)",
  fractional: "Fractional",
  american: "American",
};
